import React from 'react'
import { Badge } from 'react-bootstrap'
import { BsGlobe, BsShield } from 'react-icons/bs'
import { MdCreditCard, MdShield } from 'react-icons/md'

export default function Tags() {
  return (
    <div>
        <div className='d-md-flex flex-row justify-content-center align-items-center'>
            <Badge pill className='m-2 p-2' bg='dark'>
                <span className='m-2'><BsGlobe/></span>
                <span className='m-2'>بدون نیاز به اینترنت خارجی </span>
            </Badge>
            <Badge pill className='m-2 p-2' bg='dark'>
                <span className='m-2'><MdShield/></span>
                <span className='m-2'>امنیت اطلاعات </span>
            </Badge>
            <Badge pill className='m-2 p-2' bg='dark'>
                <span className='m-2'><MdCreditCard/></span>
                <span className='m-2'>بدون نیاز به پرداخت هزینه های دلاری </span>
            </Badge>
        </div>
    </div>
  )
}
